import Vue from "vue";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

const doNotUpload = ["access_token=", "password="]; // urls with these query paramaters will have everything removed after them before going to a breadcrumb.

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: config.dsnSentry ? config.dsnSentry : "https://01de3e03ba3d48869ad2522de8326cc5@sentry.eencloud.com/3",
    release: process.env.RELEASE_VERSION,
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true
      }),
      new Integrations.BrowserTracing(),
    ],
    environment: gtm_env === "env-1" ? "production" : "test",
    tracesSampleRate: 1.0,
    beforeBreadcrumb(breadcrumb) {
      doNotUpload.forEach(string => {
        if(breadcrumb.category === "xhr") {
          const index = breadcrumb.data.url.indexOf(string);
          if(index !== -1) {
            breadcrumb.data.url = breadcrumb.data.url.substring(0, index + string.length);
          }
        }
      })
      return breadcrumb;
    }
  });
}

export default Sentry;

export async function SentryProfiling(name, data, description, method) {
  const transaction = Sentry.startTransaction({ name });
  Sentry.configureScope(scope => scope.setSpan(transaction));
  Sentry.configureScope(scope => scope.setTransactionName(name));

  const span = transaction.startChild({
    data,
    op: 'task',
    description,
  });
  
  function endProfiling(shouldSend = true) {
    const timer = (new Date().getTime()/1000) - transaction.startTimestamp;
    if (!shouldSend || timer > 35) transaction.endTimestamp = 0;
    span.finish();
    transaction.finish();
  }

  await method(endProfiling)
}